import authRepo from './../../api/repos/authRepo'

const state = {
  user: null,
  permissions: null,
  token: null
}

const mutations = {
  setAuth: state => {
    state.user = JSON.parse(localStorage.getItem('user'))
    state.permissions = JSON.parse(localStorage.getItem('permissions'))
    state.token = localStorage.getItem('token')
  },

  clearAuth: state => {
    state.user = null
    state.token = null
    state.permissions = null
  }
}

const getters = {
  user: state => state.user,
  permissions: state => state.permissions
}

const actions = {
  doCheckAuth: async ({ commit }, credentials) => {
    let { data } = await authRepo.login(credentials)

    setToLocalStorage(data)
    commit('setAuth')
  },

  doLogout: async ({ commit }) => {
    try {
      await authRepo.logout()
    } finally {
      clearFromLocalStorage()
      commit('clearAuth')
    }
  },

  doLogoutAll: async ({ commit }) => {
    try {
      await authRepo.logoutAll()
    } finally {
      clearFromLocalStorage()
      commit('clearAuth')
    }
  },

  doUpdateAccount: async ({ commit }, user) => {
    let { data } = await authRepo.updateAccount(user)
    setToLocalStorage(data)
    commit('setAuth')
  }
}

const setToLocalStorage = data => {
  localStorage.setItem('user', JSON.stringify(data.user))
  if (data.token) localStorage.setItem('token', data.token)
  if (data.permissions) localStorage.setItem('permissions', JSON.stringify(data.permissions))
}

const clearFromLocalStorage = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  localStorage.removeItem('permissions')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
